
(function () {

    /* =====================================================
       COMMON HELPERS
    ===================================================== */

    function getHiddenVariants() {
        return window.hiddenVariants || [];
    }

    function hasMultipleOptions(hiddenVariants) {
        return hiddenVariants.some(function (variant) {
            return variant.option2 || variant.option3;
        });
    }

    // Get the option name from a Swatch King item.
    function getOptionName(item) {

        const optionElement = item.matches('[swatch-option]')
            ? item
            : item.querySelector('[swatch-option]');

        return optionElement
            ? optionElement.getAttribute('swatch-option')
            : null;
    }

    // Get the option value from a Swatch King item.
    function getOptionValue(item) {

        const optionElement = item.matches('[swatch-option]')
            ? item
            : item.querySelector('[swatch-option]');

        return (
            item.getAttribute('orig-value') ||
            (optionElement && optionElement.getAttribute('orig-value')) ||
            (optionElement && optionElement.getAttribute('data-value')) ||
            item.getAttribute('value') ||
            ''
        ).trim();
    }

    // Get the currently selected option inside a container.
    function getSelectedOption(container, optionName) {

        const items = container.querySelectorAll('.swatch-view-item');

        for (const item of items) {

            if (item.getAttribute('aria-checked') !== 'true') {
                continue;
            }

            if (getOptionName(item) === optionName) {
                return getOptionValue(item);
            }

            const child = item.querySelector(
                '[swatch-option="' + optionName + '"]'
            );

            if (child) {
                return getOptionValue(item);
            }
        }

        return null;
    }


    /* =====================================================
       PRODUCT PAGE
       Handles:
       - Single option products (example: Teal)
       - Multiple option products (example: Hybrid / Ocean Blue)
       - Button swatches
    ===================================================== */

    function shouldHideProductSwatch(item) {

        const hiddenVariants = getHiddenVariants();

        if (!hiddenVariants.length) return false;

        const optionName = getOptionName(item);
        const value = getOptionValue(item);

        if (!optionName || !value) return false;

        const multipleOptions = hasMultipleOptions(hiddenVariants);

        /*
         * SINGLE OPTION PRODUCT
         *
         * Example:
         * option1 = Color
         * Teal = hidden
         */
        if (!multipleOptions && optionName === 'option1') {

            return hiddenVariants.some(function (variant) {
                return variant.option1 === value;
            });
        }

        /*
         * MULTI OPTION PRODUCT
         *
         * Example:
         * option1 = Shape
         * option2 = Color
         *
         * Never hide option1.
         */
        if (optionName === 'option1') {
            return false;
        }

        const selectedOption1 = getSelectedOption(
            document,
            'option1'
        );

        const selectedOption2 = getSelectedOption(
            document,
            'option2'
        );

        // Hide matching option2 values under selected option1.
        if (optionName === 'option2') {

            return hiddenVariants.some(function (variant) {

                if (
                    selectedOption1 &&
                    variant.option1 !== selectedOption1
                ) {
                    return false;
                }

                return variant.option2 === value;
            });
        }

        // Handle third option.
        if (optionName === 'option3') {

            return hiddenVariants.some(function (variant) {

                if (
                    selectedOption1 &&
                    variant.option1 !== selectedOption1
                ) {
                    return false;
                }

                if (
                    selectedOption2 &&
                    variant.option2 !== selectedOption2
                ) {
                    return false;
                }

                return variant.option3 === value;
            });
        }

        return false;
    }


    function hideProductSwatches() {

        document.querySelectorAll(
            'variant-swatch-king .swatch-view-item[orig-value]'
        ).forEach(function (item) {

            item.style.display = shouldHideProductSwatch(item)
                ? 'none'
                : '';

        });
    }


    /* =====================================================
       COLLECTION PAGE
       Handles:
       - Single option products
       - Multiple option products
       - Button swatches
       - Dropdown swatches
       - Separate product color circles
    ===================================================== */

    function removeHiddenSwatches() {

        document.querySelectorAll(
            '.grid-product[data-hidden-variants]'
        ).forEach(function (card) {

            let hiddenVariants = [];

            try {

                hiddenVariants = JSON.parse(
                    card.getAttribute('data-hidden-variants') || '[]'
                );

            } catch (error) {

                console.error(
                    'Unable to parse hidden variants:',
                    error
                );

                return;
            }

            if (!hiddenVariants.length) return;

            const multipleOptions = hasMultipleOptions(hiddenVariants);

            const selectedOption1 = getSelectedOption(
                card,
                'option1'
            );

            const selectedOption2 = getSelectedOption(
                card,
                'option2'
            );


            // Determine whether an option value should be hidden.
            function shouldHideValue(optionName, value) {

                if (!value || !optionName) return false;

                /*
                 * SINGLE OPTION PRODUCT
                 * Hide option1 values such as Teal.
                 */
                if (!multipleOptions && optionName === 'option1') {

                    return hiddenVariants.some(function (variant) {
                        return variant.option1 === value;
                    });
                }

                // Never hide option1 on multi-option products.
                if (optionName === 'option1') {
                    return false;
                }

                // OPTION 2: Color.
                if (optionName === 'option2') {

                    return hiddenVariants.some(function (variant) {

                        if (
                            selectedOption1 &&
                            variant.option1 !== selectedOption1
                        ) {
                            return false;
                        }

                        return variant.option2 === value;
                    });
                }

                // OPTION 3.
                if (optionName === 'option3') {

                    return hiddenVariants.some(function (variant) {

                        if (
                            selectedOption1 &&
                            variant.option1 !== selectedOption1
                        ) {
                            return false;
                        }

                        if (
                            selectedOption2 &&
                            variant.option2 !== selectedOption2
                        ) {
                            return false;
                        }

                        return variant.option3 === value;
                    });
                }

                return false;
            }


            /*
             * Process Swatch King button and dropdown options.
             *
             * Button:
             * .swatch-view-item
             *
             * Dropdown:
             * .swatch-drop-down-list-item
             */
            card.querySelectorAll(
                'variant-swatch-king .swatch-view-item[orig-value], ' +
                'variant-swatch-king .swatch-drop-down-list-item[orig-value]'
            ).forEach(function (item) {

                const optionName = getOptionName(item);
                const value = getOptionValue(item);

                item.style.display = shouldHideValue(
                    optionName,
                    value
                ) ? 'none' : '';

            });


            /*
             * Process separate product grid color circles.
             *
             * Example aria-label:
             * Coral 16mm - Ocean Blue
             */
            card.querySelectorAll(
                '.grid-product__colors a.color-swatch[aria-label]'
            ).forEach(function (swatch) {

                const label = swatch.getAttribute('aria-label') || '';
                const value = label.split(' - ').pop().trim();

                const optionName = multipleOptions
                    ? 'option2'
                    : 'option1';

                swatch.style.display = shouldHideValue(
                    optionName,
                    value
                ) ? 'none' : '';

            });

        });
    }


    /* =====================================================
       REBUY CROSS-SELL
       Existing hidden variant IDs
    ===================================================== */

    const rebuyHiddenVariantIds = [
        '48916732903728-1',
        '50729129476381',
        '50519736123677'
    ];

    function hideRebuyVariants() {

        document.querySelectorAll(
            '.rebuy-product-block'
        ).forEach(function (product) {

            // Dropdown options.
            product.querySelectorAll(
                '.rebuy-select option'
            ).forEach(function (option) {

                if (
                    rebuyHiddenVariantIds.includes(
                        option.value.trim()
                    )
                ) {
                    option.remove();
                }

            });

            // Radio / button swatches.
            product.querySelectorAll(
                '.rebuy-product-options__button-swatch'
            ).forEach(function (swatch) {

                const input = swatch.querySelector('input');

                if (
                    input &&
                    rebuyHiddenVariantIds.includes(input.value.trim())
                ) {
                    swatch.remove();
                }

            });

        });
    }


    /* =====================================================
       INITIAL EXECUTION
    ===================================================== */

    function runAllHiddenVariantFunctions() {

        hideProductSwatches();
        removeHiddenSwatches();
        hideRebuyVariants();

    }

    runAllHiddenVariantFunctions();


    /* =====================================================
       PRODUCT PAGE OBSERVER
    ===================================================== */

    const productObserver = new MutationObserver(function () {
        hideProductSwatches();
    });

    productObserver.observe(document.body, {
        childList: true,
        subtree: true
    });


    /* =====================================================
       COLLECTION PAGE OBSERVER
    ===================================================== */

    const collectionObserver = new MutationObserver(function (mutations) {

        let shouldUpdate = false;

        mutations.forEach(function (mutation) {

            mutation.addedNodes.forEach(function (node) {

                if (node.nodeType !== 1) return;

                if (
                    node.matches?.(
                        '.grid-product, variant-swatch-king'
                    ) ||
                    node.querySelector?.(
                        '.grid-product, variant-swatch-king'
                    )
                ) {
                    shouldUpdate = true;
                }

            });

        });

        if (shouldUpdate) {
            removeHiddenSwatches();
        }

    });

    collectionObserver.observe(document.body, {
        childList: true,
        subtree: true
    });


    /* =====================================================
       REBUY OBSERVER
    ===================================================== */

    const rebuyObserver = new MutationObserver(function () {
        hideRebuyVariants();
    });

    rebuyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });


    /* =====================================================
       HANDLE SWATCH SELECTION
    ===================================================== */

    document.addEventListener('click', function (event) {

        const swatch = event.target.closest(
            '.swatch-view-item, .swatch-drop-down-list-item'
        );

        if (!swatch) return;

        setTimeout(function () {
            runAllHiddenVariantFunctions();
        }, 100);

    });


    /* =====================================================
       RECHECK AFTER DYNAMIC CONTENT LOAD
    ===================================================== */

    let attempts = 0;

    const hiddenVariantInterval = setInterval(function () {

        runAllHiddenVariantFunctions();

        attempts++;

        if (attempts >= 20) {
            clearInterval(hiddenVariantInterval);
        }

    }, 500);


})();
